import { Dayjs } from "dayjs"
import { IFlexMarketSubscription } from "./flexMarketSubscription.types"

export class FlexMarketSubscription implements IFlexMarketSubscription {
  constructor(
    public onboardedAt: Dayjs,
    public meterpointIdentifier: string,
    public offboardedAt?: Dayjs,
  ) {}

  get isActive(): boolean {
    return !this.offboardedAt
  }
}
